/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {Tooltip} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {translate} from '@ion/core/src/locale/locale';
import {IconButton} from '@ion/dls/src/components/buttons/IconButton';
import {MoveEntityIcon} from '@ion/dls/src/icons/MoveEntityIcon';
import {dlsAlt, dlsColor} from '@ion/dls/src/theme/theme';

const tooltip = makeStyles(theme => ({
  arrow : {
    color : dlsColor('grey1')
  },
  tooltip : {
    ...dlsAlt('components', 'iconTooltip'),
    fontSize : '12px !important'
  }
}));

export const MoveTooltip = props => (
  <Tooltip arrow classes={tooltip()} title={translate('common:editors.move.tooltip')} {...props}/>
);

// defines the container props ...
export type MoveGridButtonProps = {
  onMove: (params?: boolean) => void,
  disabled?: boolean
};

/**
 * The MoveGridButton provides the Refresh Icon Button which provides the state
 * and labels common amongst refresh the grid
 *
 * ```typescript
 *   import {MoveGridButton} from '@ion/dls/src/components/buttons/';
 *
 *   <MoveGridButton onMove={onMove} />
 * ```
 */
export const MoveGridButton = ({onMove, disabled = false}: MoveGridButtonProps) => {
  return (
    <MoveTooltip>
      <div>
        <IconButton icon={<MoveEntityIcon />}
          onClick={onMove}
          disabled={disabled}
          style={{boxShadow: 'unset'}}
          backgroundColor={disabled ? 'transparent !important' : null} />
      </div>
    </MoveTooltip>
  );
};

export default MoveGridButton;
